<template>
  <div></div>
</template>
<script>
import { getAppStatus } from '@/utils/app';
import { getThirdNorthUrlApi } from '@/api/base1';

export default {
  name: 'NorthInterim',
  computed: {
    cuserId() {
      return getAppStatus().cuserId;
      // return '1e893452-da8a-44fa-aaeb-7f7cc6bd02b4';
    },
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      const { cuserId } = this;
      const { type, rangeId } = this.$route.query;
      let res;
      try {
        res = await getThirdNorthUrlApi({
          cuserId,
          type,
          rangeId,
        });
      } catch (e) {
        console.log(e);
        return this.$toast(e?.desc || '网络异常');
      }
      if (res?.code === 1) {
        window.location.replace(res?.results);
      }
    },
  },
};
</script>
